// Dati completi delle città italiane organizzate per provincia
export interface ProvinceData {
  name: string;
  region: string;
  capital: string;
  mainCities: string[];
}

export const italianProvinces: ProvinceData[] = [
  // TICINO
  {
    name: 'Chiasso',
    region: 'Ticino',
    capital: 'Lugano',
    mainCities: ['Chiasso', 'Lugano', 'Bellinzona', 'Locarno', 'Mendrisio', 'Biasca', 'Ascona', 'Giubiasco', 'Tenero-Contra', 'Cadenazzo']
  },
  {
    name: 'Lugano',
    region: 'Ticino',
    capital: 'Lugano',
    mainCities: ['Lugano', 'Mendrisio', 'Bellinzona', 'Locarno', 'Chiasso', 'Ascona', 'Biasca', 'Giubiasco', 'Tenero-Contra', 'Cadenazzo']
  },
  {
    name: 'Mendrisio',
    region: 'Ticino',
    capital: 'Lugano',
    mainCities: ['Mendrisio', 'Chiasso', 'Lugano', 'Bellinzona', 'Locarno', 'Ascona', 'Biasca', 'Giubiasco', 'Tenero-Contra', 'Cadenazzo']
  },
  // LAZIO
  {
    name: 'Roma',
    region: 'Lazio',
    capital: 'Roma',
    mainCities: ['Roma', 'Tivoli', 'Anzio', 'Nettuno', 'Frascati', 'Marino', 'Albano Laziale', 'Ciampino', 'Pomezia', 'Fiumicino']
  },
  {
    name: 'Frosinone',
    region: 'Lazio',
    capital: 'Frosinone',
    mainCities: ['Frosinone', 'Cassino', 'Sora', 'Anagni', 'Ferentino', 'Alatri', 'Ceccano', 'Pontecorvo']
  },
  {
    name: 'Latina',
    region: 'Lazio',
    capital: 'Latina',
    mainCities: ['Latina', 'Aprilia', 'Terracina', 'Formia', 'Cisterna di Latina', 'Sabaudia', 'Ponza', 'Gaeta']
  },
  {
    name: 'Rieti',
    region: 'Lazio',
    capital: 'Rieti',
    mainCities: ['Rieti', 'Cittaducale', 'Poggio Bustone', 'Antrodoco', 'Borgorose']
  },
  {
    name: 'Viterbo',
    region: 'Lazio',
    capital: 'Viterbo',
    mainCities: ['Viterbo', 'Civita Castellana', 'Montefiascone', 'Tarquinia', 'Tuscania', 'Orte', 'Ronciglione']
  },

  // LOMBARDIA
  {
    name: 'Milano',
    region: 'Lombardia',
    capital: 'Milano',
    mainCities: ['Milano', 'Sesto San Giovanni', 'Cinisello Balsamo', 'Cologno Monzese', 'Rho', 'Legnano', 'Bollate', 'Corsico', 'San Donato Milanese', 'Segrate']
  },
  {
    name: 'Bergamo',
    region: 'Lombardia',
    capital: 'Bergamo',
    mainCities: ['Bergamo', 'Treviglio', 'Romano di Lombardia', 'Dalmine', 'Seriate', 'Albino', 'Nembro']
  },
  {
    name: 'Brescia',
    region: 'Lombardia',
    capital: 'Brescia',
    mainCities: ['Brescia', 'Desenzano del Garda', 'Montichiari', 'Chiari', 'Lumezzane', 'Gardone Val Trompia', 'Salò']
  },
  {
    name: 'Como',
    region: 'Lombardia',
    capital: 'Como',
    mainCities: ['Como', 'Cantù', 'Erba', 'Mariano Comense', 'Olgiate Comasco', 'Menaggio', 'Bellagio']
  },
  {
    name: 'Cremona',
    region: 'Lombardia',
    capital: 'Cremona',
    mainCities: ['Cremona', 'Crema', 'Casalmaggiore', 'Soresina', 'Castelleone']
  },
  {
    name: 'Mantova',
    region: 'Lombardia',
    capital: 'Mantova',
    mainCities: ['Mantova', 'Castiglione delle Stiviere', 'Suzzara', 'Viadana', 'Gonzaga']
  },
  {
    name: 'Pavia',
    region: 'Lombardia',
    capital: 'Pavia',
    mainCities: ['Pavia', 'Vigevano', 'Voghera', 'Mortara', 'Stradella', 'Belgioioso']
  },
  {
    name: 'Sondrio',
    region: 'Lombardia',
    capital: 'Sondrio',
    mainCities: ['Sondrio', 'Morbegno', 'Tirano', 'Chiavenna', 'Bormio', 'Livigno']
  },
  {
    name: 'Varese',
    region: 'Lombardia',
    capital: 'Varese',
    mainCities: ['Varese', 'Busto Arsizio', 'Gallarate', 'Saronno', 'Tradate', 'Laveno-Mombello', 'Luino']
  },
  {
    name: 'Lecco',
    region: 'Lombardia',
    capital: 'Lecco',
    mainCities: ['Lecco', 'Merate', 'Calolziocorte', 'Valmadrera', 'Mandello del Lario']
  },
  {
    name: 'Lodi',
    region: 'Lombardia',
    capital: 'Lodi',
    mainCities: ['Lodi', 'Codogno', 'Sant\'Angelo Lodigiano', 'Casalpusterlengo']
  },
  {
    name: 'Monza e Brianza',
    region: 'Lombardia',
    capital: 'Monza',
    mainCities: ['Monza', 'Seregno', 'Desio', 'Limbiate', 'Cesano Maderno', 'Carate Brianza', 'Vimercate']
  },

  // CAMPANIA
  {
    name: 'Napoli',
    region: 'Campania',
    capital: 'Napoli',
    mainCities: ['Napoli', 'Pozzuoli', 'Torre del Greco', 'Castellammare di Stabia', 'Portici', 'Ercolano', 'Nola', 'Giugliano in Campania', 'Aversa', 'Casoria']
  },
  {
    name: 'Avellino',
    region: 'Campania',
    capital: 'Avellino',
    mainCities: ['Avellino', 'Ariano Irpino', 'Atripalda', 'Solofra', 'Montoro', 'Mercogliano']
  },
  {
    name: 'Benevento',
    region: 'Campania',
    capital: 'Benevento',
    mainCities: ['Benevento', 'Montesarchio', 'San Giorgio del Sannio', 'Telese Terme', 'Airola']
  },
  {
    name: 'Caserta',
    region: 'Campania',
    capital: 'Caserta',
    mainCities: ['Caserta', 'Marcianise', 'Aversa', 'Maddaloni', 'Santa Maria Capua Vetere', 'Capua', 'Sessa Aurunca']
  },
  {
    name: 'Salerno',
    region: 'Campania',
    capital: 'Salerno',
    mainCities: ['Salerno', 'Battipaglia', 'Cava de\' Tirreni', 'Nocera Inferiore', 'Scafati', 'Amalfi', 'Positano', 'Agropoli', 'Vallo della Lucania']
  },

  // PIEMONTE
  {
    name: 'Torino',
    region: 'Piemonte',
    capital: 'Torino',
    mainCities: ['Torino', 'Moncalieri', 'Collegno', 'Rivoli', 'Settimo Torinese', 'Nichelino', 'Chieri', 'Ivrea', 'Pinerolo', 'Chivasso']
  },
  {
    name: 'Alessandria',
    region: 'Piemonte',
    capital: 'Alessandria',
    mainCities: ['Alessandria', 'Casale Monferrato', 'Valenza', 'Novi Ligure', 'Tortona', 'Acqui Terme']
  },
  {
    name: 'Asti',
    region: 'Piemonte',
    capital: 'Asti',
    mainCities: ['Asti', 'Nizza Monferrato', 'Canelli', 'San Damiano d\'Asti']
  },
  {
    name: 'Biella',
    region: 'Piemonte',
    capital: 'Biella',
    mainCities: ['Biella', 'Cossato', 'Valdilana', 'Candelo']
  },
  {
    name: 'Cuneo',
    region: 'Piemonte',
    capital: 'Cuneo',
    mainCities: ['Cuneo', 'Alba', 'Bra', 'Fossano', 'Mondovì', 'Savigliano', 'Saluzzo']
  },
  {
    name: 'Novara',
    region: 'Piemonte',
    capital: 'Novara',
    mainCities: ['Novara', 'Borgomanero', 'Arona', 'Trecate', 'Galliate', 'Cameri']
  },
  {
    name: 'Verbano-Cusio-Ossola',
    region: 'Piemonte',
    capital: 'Verbania',
    mainCities: ['Verbania', 'Domodossola', 'Omegna', 'Stresa', 'Baveno', 'Cannobio']
  },
  {
    name: 'Vercelli',
    region: 'Piemonte',
    capital: 'Vercelli',
    mainCities: ['Vercelli', 'Santhià', 'Borgosesia', 'Gattinara', 'Trino']
  },

  // TOSCANA
  {
    name: 'Firenze',
    region: 'Toscana',
    capital: 'Firenze',
    mainCities: ['Firenze', 'Prato', 'Empoli', 'Scandicci', 'Sesto Fiorentino', 'Campi Bisenzio', 'Figline e Incisa Valdarno', 'Pontassieve']
  },
  {
    name: 'Arezzo',
    region: 'Toscana',
    capital: 'Arezzo',
    mainCities: ['Arezzo', 'Cortona', 'San Giovanni Valdarno', 'Montevarchi', 'Cavriglia', 'Sansepolcro']
  },
  {
    name: 'Grosseto',
    region: 'Toscana',
    capital: 'Grosseto',
    mainCities: ['Grosseto', 'Follonica', 'Orbetello', 'Monte Argentario', 'Castiglione della Pescaia', 'Massa Marittima']
  },
  {
    name: 'Livorno',
    region: 'Toscana',
    capital: 'Livorno',
    mainCities: ['Livorno', 'Piombino', 'Cecina', 'Rosignano Marittimo', 'Portoferraio', 'Elba']
  },
  {
    name: 'Lucca',
    region: 'Toscana',
    capital: 'Lucca',
    mainCities: ['Lucca', 'Viareggio', 'Forte dei Marmi', 'Pietrasanta', 'Massarosa', 'Camaiore', 'Capannori']
  },
  {
    name: 'Massa-Carrara',
    region: 'Toscana',
    capital: 'Massa',
    mainCities: ['Massa', 'Carrara', 'Montignoso', 'Aulla', 'Pontremoli']
  },
  {
    name: 'Pisa',
    region: 'Toscana',
    capital: 'Pisa',
    mainCities: ['Pisa', 'Cascina', 'San Giuliano Terme', 'Pontedera', 'Volterra', 'San Miniato']
  },
  {
    name: 'Pistoia',
    region: 'Toscana',
    capital: 'Pistoia',
    mainCities: ['Pistoia', 'Montecatini Terme', 'Pescia', 'Quarrata', 'Monsummano Terme', 'Agliana']
  },
  {
    name: 'Prato',
    region: 'Toscana',
    capital: 'Prato',
    mainCities: ['Prato', 'Montemurlo', 'Carmignano', 'Poggio a Caiano', 'Cantagallo', 'Vernio', 'Vaiano']
  },
  {
    name: 'Siena',
    region: 'Toscana',
    capital: 'Siena',
    mainCities: ['Siena', 'Poggibonsi', 'Colle di Val d\'Elsa', 'Montepulciano', 'Chiusi', 'San Gimignano', 'Montalcino']
  },

  // EMILIA-ROMAGNA
  {
    name: 'Bologna',
    region: 'Emilia-Romagna',
    capital: 'Bologna',
    mainCities: ['Bologna', 'Imola', 'Casalecchio di Reno', 'San Lazzaro di Savena', 'Castel Maggiore', 'Zola Predosa', 'Pianoro']
  },
  {
    name: 'Ferrara',
    region: 'Emilia-Romagna',
    capital: 'Ferrara',
    mainCities: ['Ferrara', 'Cento', 'Comacchio', 'Argenta', 'Bondeno']
  },
  {
    name: 'Forlì-Cesena',
    region: 'Emilia-Romagna',
    capital: 'Forlì',
    mainCities: ['Forlì', 'Cesena', 'Faenza', 'Cervia', 'Cesenatico', 'Savignano sul Rubicone']
  },
  {
    name: 'Modena',
    region: 'Emilia-Romagna',
    capital: 'Modena',
    mainCities: ['Modena', 'Carpi', 'Sassuolo', 'Formigine', 'Maranello', 'Mirandola', 'Vignola']
  },
  {
    name: 'Parma',
    region: 'Emilia-Romagna',
    capital: 'Parma',
    mainCities: ['Parma', 'Fidenza', 'Salsomaggiore Terme', 'Collecchio', 'Felino', 'Langhirano']
  },
  {
    name: 'Piacenza',
    region: 'Emilia-Romagna',
    capital: 'Piacenza',
    mainCities: ['Piacenza', 'Castel San Giovanni', 'Fiorenzuola d\'Arda', 'Rottofreno', 'Podenzano']
  },
  {
    name: 'Ravenna',
    region: 'Emilia-Romagna',
    capital: 'Ravenna',
    mainCities: ['Ravenna', 'Faenza', 'Lugo', 'Cervia', 'Russi', 'Bagnacavallo']
  },
  {
    name: 'Reggio Emilia',
    region: 'Emilia-Romagna',
    capital: 'Reggio Emilia',
    mainCities: ['Reggio Emilia', 'Correggio', 'Guastalla', 'Scandiano', 'Cavriago', 'Montecchio Emilia']
  },
  {
    name: 'Rimini',
    region: 'Emilia-Romagna',
    capital: 'Rimini',
    mainCities: ['Rimini', 'Riccione', 'Cattolica', 'Bellaria-Igea Marina', 'Misano Adriatico', 'San Giovanni in Marignano']
  },

  // VENETO
  {
    name: 'Venezia',
    region: 'Veneto',
    capital: 'Venezia',
    mainCities: ['Venezia', 'Mestre', 'Marghera', 'Mira', 'Spinea', 'Mirano', 'Dolo', 'Chioggia', 'San Donà di Piave']
  },
  {
    name: 'Belluno',
    region: 'Veneto',
    capital: 'Belluno',
    mainCities: ['Belluno', 'Feltre', 'Cortina d\'Ampezzo', 'Auronzo di Cadore', 'Agordo']
  },
  {
    name: 'Padova',
    region: 'Veneto',
    capital: 'Padova',
    mainCities: ['Padova', 'Abano Terme', 'Montegrotto Terme', 'Cittadella', 'Camposampiero', 'Este', 'Monselice']
  },
  {
    name: 'Rovigo',
    region: 'Veneto',
    capital: 'Rovigo',
    mainCities: ['Rovigo', 'Adria', 'Porto Viro', 'Lendinara', 'Badia Polesine']
  },
  {
    name: 'Treviso',
    region: 'Veneto',
    capital: 'Treviso',
    mainCities: ['Treviso', 'Conegliano', 'Vittorio Veneto', 'Castelfranco Veneto', 'Montebelluna', 'Oderzo']
  },
  {
    name: 'Verona',
    region: 'Veneto',
    capital: 'Verona',
    mainCities: ['Verona', 'Villafranca di Verona', 'San Bonifacio', 'Legnago', 'Bussolengo', 'Caprino Veronese']
  },
  {
    name: 'Vicenza',
    region: 'Veneto',
    capital: 'Vicenza',
    mainCities: ['Vicenza', 'Bassano del Grappa', 'Schio', 'Thiene', 'Arzignano', 'Marostica', 'Asiago']
  },

  // LIGURIA
  {
    name: 'Genova',
    region: 'Liguria',
    capital: 'Genova',
    mainCities: ['Genova', 'Rapallo', 'Chiavari', 'Sestri Levante', 'Santa Margherita Ligure', 'Camogli', 'Portofino']
  },
  {
    name: 'Imperia',
    region: 'Liguria',
    capital: 'Imperia',
    mainCities: ['Imperia', 'Sanremo', 'Ventimiglia', 'Bordighera', 'Diano Marina', 'Taggia']
  },
  {
    name: 'La Spezia',
    region: 'Liguria',
    capital: 'La Spezia',
    mainCities: ['La Spezia', 'Sarzana', 'Lerici', 'Portovenere', 'Monterosso al Mare', 'Vernazza', 'Riomaggiore']
  },  {
    name: 'Savona',
    region: 'Liguria',
    capital: 'Savona',
    mainCities: ['Savona', 'Albenga', 'Finale Ligure', 'Loano', 'Pietra Ligure', 'Varazze', 'Albisola Superiore']
  },

  // SICILIA
  {
    name: 'Palermo',
    region: 'Sicilia',
    capital: 'Palermo',
    mainCities: ['Palermo', 'Bagheria', 'Carini', 'Monreale', 'Partinico', 'Termini Imerese', 'Cefalù', 'Corleone']
  },
  {
    name: 'Catania',
    region: 'Sicilia',
    capital: 'Catania',
    mainCities: ['Catania', 'Acireale', 'Misterbianco', 'Paternò', 'Belpasso', 'Gravina di Catania', 'Mascalucia', 'Giarre']
  },
  {
    name: 'Messina',
    region: 'Sicilia',
    capital: 'Messina',
    mainCities: ['Messina', 'Barcellona Pozzo di Gotto', 'Milazzo', 'Patti', 'Taormina', 'Lipari', 'Sant\'Agata di Militello']
  },
  {
    name: 'Siracusa',
    region: 'Sicilia',
    capital: 'Siracusa',
    mainCities: ['Siracusa', 'Augusta', 'Avola', 'Noto', 'Pachino', 'Lentini', 'Floridia']
  },
  {
    name: 'Trapani',
    region: 'Sicilia',
    capital: 'Trapani',
    mainCities: ['Trapani', 'Marsala', 'Mazara del Vallo', 'Alcamo', 'Castelvetrano', 'Erice', 'Favignana']
  },
  {
    name: 'Agrigento',
    region: 'Sicilia',
    capital: 'Agrigento',
    mainCities: ['Agrigento', 'Canicattì', 'Sciacca', 'Licata', 'Porto Empedocle', 'Favara', 'Ribera']
  },
  {
    name: 'Caltanissetta',
    region: 'Sicilia',
    capital: 'Caltanissetta',
    mainCities: ['Caltanissetta', 'Gela', 'Niscemi', 'San Cataldo', 'Mussomeli', 'Serradifalco']
  },
  {
    name: 'Enna',
    region: 'Sicilia',
    capital: 'Enna',
    mainCities: ['Enna', 'Piazza Armerina', 'Leonforte', 'Nicosia', 'Troina', 'Agira']
  },
  {
    name: 'Ragusa',
    region: 'Sicilia',
    capital: 'Ragusa',
    mainCities: ['Ragusa', 'Vittoria', 'Modica', 'Comiso', 'Scicli', 'Ispica', 'Pozzallo']
  },

  // PUGLIA
  {
    name: 'Bari',
    region: 'Puglia',
    capital: 'Bari',
    mainCities: ['Bari', 'Altamura', 'Molfetta', 'Bitonto', 'Corato', 'Trani', 'Andria', 'Monopoli', 'Conversano']
  },
  {
    name: 'Lecce',
    region: 'Puglia',
    capital: 'Lecce',
    mainCities: ['Lecce', 'Gallipoli', 'Nardò', 'Casarano', 'Galatina', 'Otranto', 'Santa Maria di Leuca', 'Maglie']
  },
  {
    name: 'Taranto',
    region: 'Puglia',
    capital: 'Taranto',
    mainCities: ['Taranto', 'Grottaglie', 'Manduria', 'Martina Franca', 'Massafra', 'Ginosa', 'Castellaneta']
  },
  {
    name: 'Foggia',
    region: 'Puglia',
    capital: 'Foggia',
    mainCities: ['Foggia', 'Cerignola', 'Manfredonia', 'San Severo', 'Lucera', 'Vieste', 'Monte Sant\'Angelo']
  },
  {
    name: 'Brindisi',
    region: 'Puglia',
    capital: 'Brindisi',
    mainCities: ['Brindisi', 'Francavilla Fontana', 'Ostuni', 'Fasano', 'Mesagne', 'San Vito dei Normanni', 'Cisternino']
  },
  {
    name: 'Barletta-Andria-Trani',
    region: 'Puglia',
    capital: 'Andria',
    mainCities: ['Andria', 'Barletta', 'Trani', 'Bisceglie', 'Canosa di Puglia', 'Margherita di Savoia', 'Minervino Murge']
  },

  // CALABRIA
  {
    name: 'Reggio Calabria',
    region: 'Calabria',
    capital: 'Reggio Calabria',
    mainCities: ['Reggio Calabria', 'Villa San Giovanni', 'Palmi', 'Gioia Tauro', 'Locri', 'Siderno', 'Melito di Porto Salvo']
  },
  {
    name: 'Catanzaro',
    region: 'Calabria',
    capital: 'Catanzaro',
    mainCities: ['Catanzaro', 'Lamezia Terme', 'Crotone', 'Soverato', 'Sellia Marina', 'Chiaravalle Centrale']
  },
  {
    name: 'Cosenza',
    region: 'Calabria',
    capital: 'Cosenza',
    mainCities: ['Cosenza', 'Rende', 'Castrovillari', 'Rossano', 'Paola', 'Scalea', 'Praia a Mare', 'Diamante']
  },
  {
    name: 'Crotone',
    region: 'Calabria',
    capital: 'Crotone',
    mainCities: ['Crotone', 'Cirò Marina', 'Isola di Capo Rizzuto', 'Cutro', 'Strongoli', 'Mesoraca']
  },
  {
    name: 'Vibo Valentia',
    region: 'Calabria',
    capital: 'Vibo Valentia',
    mainCities: ['Vibo Valentia', 'Tropea', 'Pizzo', 'Mileto', 'Serra San Bruno', 'Soriano Calabro']
  },

  // SARDEGNA
  {
    name: 'Cagliari',
    region: 'Sardegna',
    capital: 'Cagliari',
    mainCities: ['Cagliari', 'Quartu Sant\'Elena', 'Capoterra', 'Selargius', 'Monserrato', 'Assemini', 'Iglesias']
  },
  {
    name: 'Sassari',
    region: 'Sardegna',
    capital: 'Sassari',
    mainCities: ['Sassari', 'Alghero', 'Porto Torres', 'Sorso', 'Ozieri', 'Thiesi', 'Castelsardo']
  },
  {
    name: 'Nuoro',
    region: 'Sardegna',
    capital: 'Nuoro',
    mainCities: ['Nuoro', 'Siniscola', 'Macomer', 'Dorgali', 'Orosei', 'Bitti', 'Orgosolo']
  },
  {
    name: 'Oristano',
    region: 'Sardegna',
    capital: 'Oristano',
    mainCities: ['Oristano', 'Terralba', 'Cabras', 'Bosa', 'Ghilarza', 'Marrubiu', 'Santa Giusta']
  },
  {
    name: 'Sud Sardegna',
    region: 'Sardegna',
    capital: 'Carbonia',
    mainCities: ['Carbonia', 'Iglesias', 'Sant\'Antioco', 'Portoscuso', 'Giba', 'Calasetta', 'San Giovanni Suergiu']
  },

  // FRIULI-VENEZIA GIULIA
  {
    name: 'Trieste',
    region: 'Friuli-Venezia Giulia',
    capital: 'Trieste',
    mainCities: ['Trieste', 'Muggia', 'San Dorligo della Valle', 'Sgonico', 'Monrupino', 'Duino-Aurisina']
  },
  {
    name: 'Udine',
    region: 'Friuli-Venezia Giulia',
    capital: 'Udine',
    mainCities: ['Udine', 'Lignano Sabbiadoro', 'Tarvisio', 'Palmanova', 'Cividale del Friuli', 'Gemona del Friuli', 'Tolmezzo']
  },
  {
    name: 'Pordenone',
    region: 'Friuli-Venezia Giulia',
    capital: 'Pordenone',
    mainCities: ['Pordenone', 'Sacile', 'Maniago', 'Spilimbergo', 'Aviano', 'Cordenons', 'Brugnera']
  },
  {
    name: 'Gorizia',
    region: 'Friuli-Venezia Giulia',
    capital: 'Gorizia',
    mainCities: ['Gorizia', 'Monfalcone', 'Gradisca d\'Isonzo', 'Staranzano', 'Ronchi dei Legionari', 'Cormons']
  },

  // TRENTINO-ALTO ADIGE
  {
    name: 'Trento',
    region: 'Trentino-Alto Adige',
    capital: 'Trento',
    mainCities: ['Trento', 'Rovereto', 'Riva del Garda', 'Arco', 'Pergine Valsugana', 'Mezzolombardo', 'Cles']
  },
  {
    name: 'Bolzano',
    region: 'Trentino-Alto Adige',
    capital: 'Bolzano',
    mainCities: ['Bolzano', 'Merano', 'Bressanone', 'Brunico', 'Vipiteno', 'Caldaro', 'Laives']
  },

  // VALLE D'AOSTA
  {
    name: 'Aosta',
    region: 'Valle d\'Aosta',
    capital: 'Aosta',
    mainCities: ['Aosta', 'Courmayeur', 'Saint-Vincent', 'Chatillon', 'Pont-Saint-Martin', 'Morgex', 'La Thuile']
  },

  // MARCHE
  {
    name: 'Ancona',
    region: 'Marche',
    capital: 'Ancona',
    mainCities: ['Ancona', 'Senigallia', 'Fabriano', 'Jesi', 'Osimo', 'Falconara Marittima', 'Chiaravalle']
  },
  {
    name: 'Pesaro e Urbino',
    region: 'Marche',
    capital: 'Pesaro',
    mainCities: ['Pesaro', 'Urbino', 'Fano', 'Cattolica', 'Gabicce Mare', 'Cagli', 'Fossombrone']
  },
  {
    name: 'Macerata',
    region: 'Marche',
    capital: 'Macerata',
    mainCities: ['Macerata', 'Civitanova Marche', 'Corridonia', 'Tolentino', 'Recanati', 'Porto Recanati', 'Camerino']
  },
  {
    name: 'Ascoli Piceno',
    region: 'Marche',
    capital: 'Ascoli Piceno',
    mainCities: ['Ascoli Piceno', 'San Benedetto del Tronto', 'Grottammare', 'Montegranaro', 'Porto Sant\'Elpidio', 'Fermo']
  },
  {
    name: 'Fermo',
    region: 'Marche',
    capital: 'Fermo',
    mainCities: ['Fermo', 'Porto Sant\'Elpidio', 'Montegranaro', 'Sant\'Elpidio a Mare', 'Monte Urano', 'Grottazzolina']
  },

  // UMBRIA
  {
    name: 'Perugia',
    region: 'Umbria',
    capital: 'Perugia',
    mainCities: ['Perugia', 'Assisi', 'Foligno', 'Città di Castello', 'Spoleto', 'Bastia Umbra', 'Marsciano', 'Gubbio']
  },
  {
    name: 'Terni',
    region: 'Umbria',
    capital: 'Terni',
    mainCities: ['Terni', 'Narni', 'Amelia', 'Orvieto', 'Allerona', 'Arrone', 'Acquasparta']
  },

  // ABRUZZO
  {
    name: 'L\'Aquila',
    region: 'Abruzzo',
    capital: 'L\'Aquila',
    mainCities: ['L\'Aquila', 'Avezzano', 'Sulmona', 'Celano', 'Pratola Peligna', 'Tagliacozzo', 'Castel di Sangro']
  },
  {
    name: 'Pescara',
    region: 'Abruzzo',
    capital: 'Pescara',
    mainCities: ['Pescara', 'Montesilvano', 'Spoltore', 'Francavilla al Mare', 'Città Sant\'Angelo', 'Penne']
  },
  {
    name: 'Chieti',
    region: 'Abruzzo',
    capital: 'Chieti',
    mainCities: ['Chieti', 'Lanciano', 'Vasto', 'Ortona', 'Atessa', 'Guardiagrele', 'San Salvo']
  },
  {
    name: 'Teramo',
    region: 'Abruzzo',
    capital: 'Teramo',
    mainCities: ['Teramo', 'Giulianova', 'Alba Adriatica', 'Pineto', 'Roseto degli Abruzzi', 'Martinsicuro', 'Silvi']
  },

  // MOLISE
  {
    name: 'Campobasso',
    region: 'Molise',
    capital: 'Campobasso',
    mainCities: ['Campobasso', 'Termoli', 'Larino', 'Bojano', 'Riccia', 'Guardialfiera', 'Campomarino']
  },
  {
    name: 'Isernia',
    region: 'Molise',
    capital: 'Isernia',
    mainCities: ['Isernia', 'Venafro', 'Agnone', 'Roccasicura', 'Sesto Campano', 'Macchiagodena']
  },

  // BASILICATA
  {
    name: 'Potenza',
    region: 'Basilicata',
    capital: 'Potenza',
    mainCities: ['Potenza', 'Melfi', 'Lavello', 'Rionero in Vulture', 'Venosa', 'Muro Lucano', 'Senise']
  },
  {
    name: 'Matera',
    region: 'Basilicata',
    capital: 'Matera',
    mainCities: ['Matera', 'Metaponto', 'Policoro', 'Nova Siri', 'Montalbano Jonico', 'Bernalda', 'Pisticci']
  }
];

// Funzione per ottenere tutte le città di una provincia
export const getCitiesByProvince = (provinceName: string): string[] => {
  const province = italianProvinces.find(p => 
    p.name.toLowerCase() === provinceName.toLowerCase()
  );
  return province ? province.mainCities : [];
};

// Funzione per ottenere tutte le città di una regione
export const getCitiesByRegion = (regionName: string): string[] => {
  const provinces = italianProvinces.filter(p => 
    p.region.toLowerCase() === regionName.toLowerCase()
  );
  return provinces.flatMap(p => p.mainCities);
};

// Funzione per trovare la provincia di una città
export const getProvinceByCity = (cityName: string): ProvinceData | null => {
  return italianProvinces.find(p => 
    p.mainCities.some(city => city.toLowerCase() === cityName.toLowerCase())
  ) || null;
};

// Funzione per verificare se una città esiste
export const cityExists = (cityName: string): boolean => {
  return italianProvinces.some(p => 
    p.mainCities.some(city => city.toLowerCase() === cityName.toLowerCase())
  );
};

// Helper function to get all unique cities from all provinces
export function getAllCities(): string[] {
  const allCities = new Set<string>();

  italianProvinces.forEach(province => {
    province.mainCities.forEach(city => {
      allCities.add(city);
    });
  });

  return Array.from(allCities).sort();
}

// Restituisce il nome canonico (capitalizzato) della città, es. "roma" -> "Roma"
export const getCanonicalCityName = (cityName: string): string | null => {
  const lower = cityName.toLowerCase();
  for (const province of italianProvinces) {
    const found = province.mainCities.find(city => city.toLowerCase() === lower);
    if (found) return found;
  }
  return null;
};
